const USERNAME = 'username';
export const SHOULD_STORE_PASSWORD = 'shouldStorePassword';
export const SILENT_LOGIN_CREDENTIALS = 'silentLoginCred';

export const setUserData = (username: string | null): void => {
  setStoredUserName(username);
  setStoredSilentLoginCred(username);
};

export const clearUserData = (): void => {
  localStorage.removeItem(USERNAME);
  localStorage.removeItem(SILENT_LOGIN_CREDENTIALS);
};

export const getStoredUsername = (): string | null =>
  localStorage.getItem(USERNAME);

const setStoredUserName = (username: string | null): void =>
  setOrRemoveItem(USERNAME, username);

export const getStoredSilentLoginCred = (): string | null =>
  localStorage.getItem(SILENT_LOGIN_CREDENTIALS);

export const setStoredSilentLoginCred = (username: string | null): void => {
  setOrRemoveItem(SILENT_LOGIN_CREDENTIALS, username);
};

export const getShouldStorePassword = (): boolean =>
  localStorage.getItem(SHOULD_STORE_PASSWORD) === 'true';

export const setShouldStorePassword = (value: boolean): void =>
  setOrRemoveItem(SHOULD_STORE_PASSWORD, value ? `${value}` : null);

const setOrRemoveItem = (key: string, value: string | null): void =>
  value ? localStorage.setItem(key, value) : localStorage.removeItem(key);
